<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-ice-cream-lolly`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M30 2a8 8 0 018 8v26a2 2 0 01-2 2H26v7a1 1 0 01-1 1h-2a1 1 0 01-1-1v-7H12a2 2 0 01-2-2V10a8 8 0 018-8h12zm-6 24c-.37 0-.861.171-1.793.635l-.3.151C20.131 27.68 19.277 28 18 28c-1.277 0-2.144-.323-3.917-1.212a63.216 63.216 0 01-.083-.042V34h20v-7.697c-.244.098-.47.221-.698.37-.105.07-.627.435-.792.541-.796.514-1.552.786-2.51.786-1.216 0-1.985-.293-3.836-1.207-.635-.314-.945-.457-1.273-.582-.384-.146-.674-.211-.891-.211zm6-20H18a4 4 0 00-4 4v12.362c.506.18 1.067.444 1.876.85 1.2.601 1.7.788 2.124.788.421 0 .91-.183 2.107-.786l.316-.159C21.883 22.328 22.823 22 24 22c.764 0 1.51.167 2.311.471.486.185.877.366 1.625.736C29.178 23.82 29.65 24 30 24c.094 0 .139-.016.338-.145.087-.056.597-.413.774-.529A7.61 7.61 0 0134 22.166V10a4 4 0 00-4-4z"/></svg>
</template>
<script>

export default {
  name: 'IconIceCreamLolly',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
